<div class="account-pages mt-5 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center">
          <a href="/" class="mb-4 d-block auth-logo">
            <img src="../../../../assets/images/logoKonnectaWhite.png" alt="logo-dark" class="logo logo-dark img-fluid">
            <img src="https://pagos-facturas.s3.amazonaws.com/Imagenes/tecsa.png" alt="logo-light" class="logo logo-light img-fluid">
          </a>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden background-login" >

          <div class="card-body p-4">
            <div class="text-center mt-2">
              <h5 class="greens">¡Bienvenido de vuelta!</h5>
              <p class="text-muted text-white">Inicia sesión para ingresar al sistema</p>
            </div>
            <div class="p-2 mt-4">
              <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                @if(error)
                { <ngb-alert type="danger" [dismissible]="false">{{ error }}</ngb-alert>
                }
                <div class="mb-3">
                  <label for="email" class="text-white">Usuario</label>
                  <input type="email" formControlName="userName" class="form-control" id="email" placeholder="Email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  @if(submitted && f.userName.errors){
                  <div class="invalid-feedback">
                    @if(f.userName.errors.required){
                    <div>Email is required</div>
                    }@if(f.userName.errors.userName){
                    <div>Email must be a valid email address</div>
                    }
                  </div>}
                </div>

                <div class="mb-3">
                  <div class="float-end">
                    <a [routerLink]="['/account/auth/request-change']" class="text-gray">¿Olvidaste tu contraseña?</a>
                </div>
                
                  <label for="password" class="text-white">Contraseña</label>
                  <div class="form-group position-relative">
                    <input required="" formControlName="password" [type]="type"
                    class="form-control" placeholder="Contraseña" autocomplete="current-password">
                    <span *ngIf="type == 'password'" class="eyeButton" (click)="myFunctionPasswordCurrent()" matSuffix>
                      <i class="fa fa-eye"></i>
                  </span>
                  <span *ngIf="type == 'text'" class="eyeButton" (click)="myFunctionPasswordCurrent()" matSuffix>
                      <i class="fa fa-eye-slash"></i>
                  </span>
                    @if(submitted && f.email.errors){
                      <div class="invalid-feedback">
                        @if(f.email.errors.required){
                        <div>Password is required</div>}
                      </div>}
                </div>
              </div>
              
<!-- 
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="auth-remember-check">
                  <label class="form-check-label" for="auth-remember-check">Recordarme</label>
                </div> -->

                <div class="mt-3 text-end">
                  <button class="btn w-sm waves-effect waves-light buttonSubmit blueButton" [disabled]="loginForm.invalid" type="submit" style="width: 40%;">
                    <dx-load-indicator *ngIf="loading" id="small-indicator" height="20" width="20"></dx-load-indicator>{{textLogin}}
                  </button>
                </div>
                <div class="mt-4 float-center">
                  <a [routerLink]="['/order/checkout']" class="text-gray">¡Realizar Pago!</a>
              </div>
                <!-- <div class="mt-4 text-center">
                  <div class="signin-other-title">
                    <h5 class="font-size-14 mb-3 title">Sign in with</h5>
                  </div>

                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="javascript:void()" class="social-list-item bg-primary text-white border-primary">
                        <i class="mdi mdi-facebook"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void()" class="social-list-item bg-info text-white border-info">
                        <i class="mdi mdi-twitter"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void()" class="social-list-item bg-danger text-white border-danger">
                        <i class="mdi mdi-google"></i>
                      </a>
                    </li>
                  </ul>
                </div> -->

                <!-- <div class="mt-4 text-center">
                  <p class="mb-0">Don't have an account ? <a href="/account/signup" class="fw-medium text-primary">
                      Signup now </a> </p>
                </div> -->
              </form>
            </div>

          </div>

        </div>

        <div class="mt-5 text-center">
          <p>Copyright {{year}} © Konnecta All rights reserved.</p>
          <!-- <p>© {{year}} Minible. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p> -->
        </div>

      </div>
    </div>
  </div>
